// extracted by mini-css-extract-plugin
export default {"second_part":"second_second_part__AEzIy","second":"second_second__TZgTL"};